module.exports = __webpack_public_path__ + "static/img/img31.98f5d4e2.png";